

























































































































































import Vue from 'vue';
import NpInput from '@/components/NpInput.vue';
import NpSelect from '@/components/NpSelect.vue';
import FormInput from '@/components/ui/FormInput.vue';
import Vehicle from '@/models/Vehicle';
import states from '@/utilities/states';
import RegistrationType from '@/models/RegistrationType';
import ReservationFields from '@/models/ReservationFields';

const fields = ['license', 'state', 'make', 'model', 'color'];

export default Vue.extend({
	name: 'VehiclesForm',
	inject: ['$validator'],
	components: {
		FormInput,
		NpInput,
		NpSelect,
	},

	props: {
		collectAll: {
			type: Boolean,
			default: false,
		},
		name: String,
		formSettings: {} as () => ReturnType<typeof RegistrationType | typeof ReservationFields>,
		type: {
			type: String,
			default: 'register',
		},
		value: {
			type: Object,
			default() {
				return new Vehicle();
			},
		},
	},

	data() {
		return {
			colors: [
				'Beige',
				'Black',
				'Blue',
				'Brown',
				'Gold',
				'Gray',
				'Green',
				'Light Blue',
				'Maroon',
				'Multi',
				'Orange',
				'Pink',
				'Purple',
				'Red',
				'Silver',
				'Turquoise',
				'White',
				'Yellow',
			],
			hasRental: false,
			newVehicle: new Vehicle() as Vehicle,
			loading: false,
			states,
		};
	},

	computed: {
		formErrors(): string[] {
			const errors: string[] = [];

			fields.forEach((field) => {
				if (this.errors.has(`${this.namePrefix}${field}`)) {
					errors.push(this.errors.first(`${this.namePrefix}${field}`));
				}
			});

			return errors;
		},

		isNewVehicle(): boolean {
			if (this.type === 'register') {
				return true;
			}

			if (!this.model.license || !this.model.state) {
				return false;
			}

			return !this.vehicles.find((vehicle: Vehicle) => this.model.license === vehicle.license && this.model.state === vehicle.state);
		},

		isRequired(): boolean {
			return this.formSettings.isRequired('vehicle_state') || this.formSettings.isRequired('vehicle_license');
		},

		isValid(): boolean {
			if (!this.isRequired || this.hasRental) {
				return true;
			}

			if (this.formSettings.isRequired('vehicle_license') && !this.model.license) {
				return false;
			}

			if (this.formSettings.isRequired('vehicle_make') && !this.model.make) {
				return false;
			}

			if (this.formSettings.isRequired('vehicle_model') && !this.model.model) {
				return false;
			}

			return true;
		},

		namePrefix(): string {
			return this.name ? `${this.name}.` : '';
		},

		model: {
			get(): Vehicle {
				return new Vehicle(this.value);
			},
			set(vehicle: Vehicle) {
				this.$emit('input', new Vehicle(vehicle));
			},
		},

		settings(): Locations.Settings {
			return this.$store.getters['location/settings'];
		},

		vehicles(): Vehicle[] {
			if (this.type === 'register') {
				return [];
			}

			return this.$store.getters.customer.vehicles as Vehicle[];
		},
	},

	mounted() {
		if (!this.model) {
			this.model = new Vehicle();
		}
	},

	methods: {
		clearErrors() {
			fields.forEach((field) => {
				this.errors.remove(`${this.namePrefix}${field}`);
			});
		},

		isSelected(vehicle: Vehicle): boolean {
			return vehicle.license === this.model.license && vehicle.state === this.model.state;
		},

		setSelectedVehicle(vehicle: Vehicle) {
			this.model = vehicle;
			this.clearErrors();
		},

		toggleRental() {
			if (this.hasRental) {
				this.model.license = 'RENTAL';
			} else {
				this.model.license = '';
			}
		},
	},
});
